/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardScore from 'solis/logic/board/score';


export default (board, date) =>
{
  new BoardScore(board).calculateAuthority(date);
};
